module.exports = __webpack_public_path__ + "683beb2a5d0ab654005fc6d2f4fc621c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icon/paper-document.svg
// module id = 2004
// module chunks = 0